/// <amd-module name="VSSUI/MasterDetailsContext" />
export { MasterDetailsContext, BaseMasterDetailsContext, bindSelectionToObservable, createChildLayer } from "./Context/MasterDetailsContext";
export { IMasterDetailsContextLayer, IMasterPanelContent, IDetailsAreaContent, IMasterDetailsContext } from "./Context/MasterDetailsContext.Types";
